<template>
  <div class="planDetailPage">
    <StickyTop />
    <Banner zoomWay="click" :slideList="slideList" :dblclickImage="dblclickImage" />
    <div class="planInfoList">
      <h3 class="planName">{{ detailData?.productName }}</h3>
      <p v-if="detailData.ctag" class="planTag" style="margin-bottom:5px;">{{ detailData?.ctag }}</p>
      <p class="preViewFlag themeRed">这是一个预览页面</p>
    </div>
    <!-- devTemp -->
    <!-- <div>selectShopVariantItem: {{ selectShopVariantItem }}</div> -->
    <!-- <div>currentSkuLis: {{ currentSkuLis.length }}</div> -->
    <!-- <div>allSkuLis: {{ allSkuLis.length }}</div> -->
    <!-- <div>applyDealerParam: {{ applyDealerParam }}</div> -->
    <!-- <div>skuAloneData: {{ skuAloneData }}</div> -->
    <!-- <div>detailData: {{ detailData }}</div> -->
    <div class="dealerInfoList">
      <van-row class="label">
        <van-col span="8">车辆：</van-col>
        <van-col span="16">XXXXXXXX</van-col>
      </van-row>
      <van-row class="label" v-if="salesAttributesTxt !== false">
        <van-col span="8">选择：</van-col>
        <van-col span="16" @click="selectSalesAttributes"
          ><span class="fvlr salesAttribute">
            <span>{{ salesAttributesTxt }}</span>
            <van-icon name="arrow" /> </span
        ></van-col>
      </van-row>
      <van-row class="label">
        <van-col span="8">销售经销商：</van-col>
        <van-col span="16">XXXXXXXX</van-col>
      </van-row>
      <van-row class="label">
        <van-col span="8">使用/服务范围:</van-col>
        <van-col span="16">XXXXXXXX</van-col>
      </van-row>
    </div>
    <SkuImg :datas="skuAloneData" />
    <!-- 底部按钮栏目 -->
    <!-- <GoodsBar :isEnterShoppingCar="isEnterShoppingCar" :isEnable="isEnable" @toShoppingCar="toShoppingCar" /> -->
    <GoodsBar :isEnterShoppingCar="isEnterShoppingCar" :isEnable="isEnable" from="shopDetail" @clickGoodBtn="clickGoodBtn">
      <ConfirmShop
        ref="confirmShopRef"
        @clickSureBtn="clickSureBtn"
        @viewContract="viewContractServiceDealHandle"
        :datas="{ shopInfoDatas, carInfoTxt, useCarInfo, preView: true }"
        :showTyreNum="showShopNum"
        :from="confirmTyreFrom"
        :type="confirmTyreType"
      />
    </GoodsBar>
    <div v-show="isShowLoad" class="loadBox">
      <van-loading size="30px" vertical color="#fff"><span style="color:#fff">加载中...</span> </van-loading>
    </div>
    <ContractServiceDeal :showPopUp="showPopUp" :datas="contractData" />
  </div>
</template>

<script>
import { reactive, toRefs, onMounted, watch, onUnmounted, computed, ref, nextTick } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { ImagePreview, Dialog } from 'vant'
import Banner from '@/components/common/Banner'
import GoodsBar from '@/components/common/GoodsBar'
import CurrentDealer from '@/components/dealer/CurrentDealer'
import ConfirmShop from '@/components/shop/ConfirmShop'
import StickyTop from '@/components/shop/StickyTop.vue'
import SkuImg from '@/components/shop/SkuImg.vue'
import UseDealer from '@/components/canUseDealer/CurrentDealer'
import ContractServiceDeal from '@/components/directSales/ContractServiceDeal'
import { getDealers } from '@/api/plan'
import { showToast } from '@/util/couponCollection'
import { couponList } from '@/util/plan'
import { addEightHour, getDistance } from '@/util'
import { useStore } from 'vuex'
import useCurrentCarInfo from '@/hooks/directSales/useCurrentCarInfo'
import useShopDetail from '@/hooks/directSales/useViewDetail'
import { addShoppingCar } from '@/api/shoppingCar'
import { getShopInfoByqrInfoKey } from '@/api/directSales'
import useContractServiceDealFn from '@/hooks/directSales/useContractServiceDeal'

export default {
  name: 'shopDetail',
  components: {
    Banner,
    CurrentDealer,
    UseDealer,
    GoodsBar,
    ConfirmShop,
    StickyTop,
    SkuImg,
    ContractServiceDeal
  },
  setup() {
    const router = useRouter()
    const route = useRoute()
    const store = useStore()
    const refShowDiffCarInfo = ref(null)
    const useDealerRef = ref()
    const confirmShopRef = ref()
    const { carInfoTxt, carInfo: useCarInfo } = useCurrentCarInfo()
    const { viewContractServiceDealFn, showPopUp, contractData } = useContractServiceDealFn()

    const {
      getShopDetailFn,
      salesAttributesTxt,
      slideList,
      dblclickImage,
      detailData,
      currentSkuLis,
      allSkuLis,
      isEnterShoppingCar,
      isEnable,
      hasDealer,
      shopInfoDatas,
      applyDealerParam,
      selectShopVariantItem
    } = useShopDetail()
    let { spuId, from, gsCode = '', boUserId = '', carInfo, salesChannel = '', qrKey = '' } = route.query
    // devTemp 1544943929577033729  1555032936493907969
    // spuId = '1555032936493907969' from=scan&salesChannel=OTRQR
    store.commit('SETSkUITEM', {})
    store.commit('SETSTEPPEROPTION', {})
    const state = reactive({
      confirmTyreFrom: '', //详情页/购物车/属性选择
      confirmTyreType: '', //立即购买/加入购物车
      showShopNum: 0,
      max: 0,
      isShowLoad: false,
      dealer: '',
      dealerJoinPlanFlag: ['loyaltyList', 'shoppingCarList', 'scan'].includes(from)
    })
    // 详情--》salesAttributes，SkuList
    // 经销商---》 SkuList
    // watchEffect(async () => {
    //   let { gsCode } = store.state.loyaltyDealerInfo
    //   let spuId = store.state.spuId
    //   if (gsCode && spuId) {
    //     try {
    //       state.currentSkuLis = await getShopSkuListByGsCode({ gsCode, spuId })
    //     } catch (error) {
    //       state.currentSkuLis = []
    //     }
    //   } else {
    //     state.currentSkuLis = []
    //   }
    // })

    // store.dispatch('setDealerJoinPlanFlag', '')
    // 设置gsCode，防止加载默认经销商
    gsCode && store.dispatch('setDealerInfo', { gs_code: gsCode, gsCode })
    const initByfrom = data => {
      const isScan = from === 'scan' || from === 'QRcode'
      // isSperate 是否运营
      let _gsCode = data.gsCode || gsCode
      const isFreeze = isScan && _gsCode
      store.commit('SETDEALERfREEZEFLAG', isFreeze)
      if (carInfo) {
        //  从生成车辆信息过来
        refShowDiffCarInfo.value.createCarInfo(carInfo)
        store.commit('SETBOUSERINFO', {
          id: boUserId
        })
      }
      if (isFreeze) {
        getDealerFn({ gsCode: _gsCode })
      }
    }
    const handleUseclick = () => {
      if (!applyDealerParam || !applyDealerParam?.value?.skuId || !applyDealerParam?.value?.gsCode) {
        showToast('请先选择销售经销商和商品')
        return
      }
      useDealerRef.value.showPop()
    }
    const getDealerFn = async data => {
      try {
        let { lat, lng } = store.state.position
        let { list = [] } = await getDealers({
          gsCode: data.gsCode,
          latitude: lat,
          longitude: lng
        })
        const dealerInfo = list[0] || {}
        dealerInfo.distance = getDistance(dealerInfo.distance)
        let _gsCode = dealerInfo.gs_code || dealerInfo.gsCode
        dealerInfo.gs_code = dealerInfo.gsCode = _gsCode
        store.dispatch('setLoyaltyDealerInfo', dealerInfo)
      } catch (e) {
        showToast(e.message, '获取经销商详情失败')
        store.dispatch('setLoyaltyDealerInfo', {})
      }
    }
    onUnmounted(() => {
      store.commit('SETDEALERfREEZEFLAG', false)
      store.commit('SETSPUID', '')
    })
    const setLoading = data => {
      state.isShowLoad = data
    }

    const showImg = index => {
      ImagePreview({
        images: dblclickImage,
        startPosition: index
      })
    }
    const toShoppingCar = () => {
      router.push({ path: '/shoppingCar', query: { event: '查看购物车' } })
    }
    const clickSureBtn = data => {
      console.log('clickSureBtn----', data)
      // clickGoodBtn(data)
      if (data.type == 'bugNow' && data.from === 'shopDetail') {
        toCreateOrder()
      }
      if (data.type == 'addShoppingCar' && data.from === 'shopDetail') {
        addShoppingCarFn()
      }
      if (data.type == 'selectAttribut' && data.from === 'shopDetail') {
        // 目前不操作数据
      }
    }
    // // 去购买下单页面
    const toCreateOrder = () => {}
    //加入购物车
    const addShoppingCarFn = async () => {}
    const selectSalesAttributes = () => {
      // console.log('salesAttributesTxt !== false', salesAttributesTxt.value, detailData.value)
      if (detailData.value?.uploadSkuCount === 1 && detailData.value?.skuList?.length === 1) {
        return
      }
      clickGoodBtn({ type: 'selectAttribut', from: 'shopDetail' })
    }
    const clickGoodBtn = data => {
      let { loyaltyDealerInfo } = store.state
      let gsCode = loyaltyDealerInfo.gsCode || loyaltyDealerInfo.gs_code
      let skuId = store.state?.skuItem?.skuId
      // if (!gsCode) {
      //   showToast('请先选择一个销售经销商')
      //   return
      // }
      if (detailData.uploadSkuCount === 1 && detailData.value?.skuList?.length === 1) {
        // 直接去结算页面

        if (!skuId) {
          showToast('请选择商品')
          return
        }
        if (data.type == 'bugNow') {
          // toCreateOrder()
        }
        if (data.type == 'addShoppingCar') {
          // addShoppingCarFn()
        }
        return
      }
      if (['selectAttribut', 'bugNow', 'addShoppingCar'].includes(data.type)) {
        state.confirmTyreFrom = data.from
        state.confirmTyreType = data.type
        nextTick(() => {
          state.showShopNum += 1
        })
      }
      if (data.type == 'toShoppingCar') {
        router.push({ path: '/shoppingCar', query: { event: '查看购物车' } })
      }
      // // 立即购买
      // data.type == 'bugNow' && toCreateOrder()
      // // 加入购物车
      // data.type == 'addShoppingCar' && addShoppingCar()
    }

    const skuImgData = computed(() => {
      return detailData.value?.detailPics
    })

    watch(
      () => store.state.position.lat,
      () => {
        initByfrom()
      }
    )
    const skuAloneData = computed(() => {
      let skuItem = store.state.skuItem
      let detailPics = detailData.value?.detailPics || []
      let skuPics = (skuItem.detailPics?.length && skuItem.detailPics) || detailPics
      return { ...skuItem, skuPics }
    })

    onMounted(async () => {
      let { loyaltyDealerInfo } = store.state
      let gsCode = loyaltyDealerInfo?.gsCode || loyaltyDealerInfo?.gs_code
      let fin = useCarInfo.value?.fin
      let qrData = {}
      let _spuId = qrData?.spuId || spuId
      let _gsCode = qrData?.gsCode || gsCode
      let _fin = qrData?.fin || fin
      let _skuId = qrData?.productId
      await getShopDetailFn({ spuId: _spuId, gsCode: _gsCode, fin: _fin, salesChannel, _skuId })
      initByfrom({ gsCode: _gsCode })
    })
    const viewContractServiceDealHandle = data => {
      console.log('viewContractServiceDealHandle', data)
      let skuId = data?.skuId || ''
      if (!skuId) {
        showToast('请先选择一个商品后预览告知书')
        return
      }
      // const notifications = state.productsData[0]?.notifications || null
      let _notifications = {
        day: '16',
        month: '3',
        year: '2022',
        effectiveMonth: 5,
        notificationFile: [
          'https://www.jiaozhu.xyz/oss/vue2/img/1.png',
          'https://www.jiaozhu.xyz/oss/vue2/img/1.png',
          'https://www.jiaozhu.xyz/oss/vue2/img/1.png'
        ],
        notificationName: 'XXXX告知书1'
      }
      _notifications = data?.notifications || {}
      let defaultKey = {
        fin: 'XXXXXXXXXXXXXXXXXX',
        contactName: 'XXXX',
        isShowMark: true,
        markMessage: '这是一个预览页',
        // 接口这个字段返回为null, 导致扫码进来不能查看告知书
        isWpProduct: 'XXX'
      }
      const notifications = { ..._notifications, ...defaultKey, productName: _notifications.skuName || '' }
      viewContractServiceDealFn(notifications)
    }

    return {
      ...toRefs(state),
      skuAloneData,
      salesAttributesTxt,
      selectShopVariantItem,
      skuImgData,
      shopInfoDatas,
      showImg,
      getShopDetailFn,
      toShoppingCar,
      setLoading,
      refShowDiffCarInfo,
      handleUseclick,
      carInfoTxt,
      useCarInfo,
      clickGoodBtn,
      slideList,
      dblclickImage,
      detailData,
      currentSkuLis,
      allSkuLis,
      isEnterShoppingCar,
      isEnable,
      hasDealer,
      applyDealerParam,
      selectSalesAttributes,
      useDealerRef,
      confirmShopRef,
      clickSureBtn,
      showPopUp,
      contractData,
      viewContractServiceDealHandle
    }
  }
}
</script>

<style lang="scss" scoped>
.planDetailPage {
  background-color: #f5f5f5;
  text-align: left;
  padding-bottom: calc(100px + constant(safe-area-inset-bottom));
  padding-bottom: calc(100px + env(safe-area-inset-bottom));
  .mySwipe {
    margin-bottom: 18px;
    img {
      width: 100%;
      height: 210px;
    }
  }
  .planInfoList {
    padding: 12px 20px;
    background-color: #fff;
    margin-bottom: 8px;
  }
  .dealerInfoList {
    padding: 18px 20px 10px;
    background-color: #fff;
  }
}
.planDetailPage::-webkit-scrollbar {
  display: none;
}
// 计划信息样式
.planInfoList {
  position: relative;
  h3 {
    font-size: 18px;
    color: #333;
    font-weight: 700;
    margin-bottom: 12px;
    margin-top: 10px;
  }
  .moneyWeenyRow {
    margin-bottom: 10px;
  }
  .moneyWeeny {
    font-size: 12px;
    color: #666;
  }
  .moneyWeight {
    font-size: 16px;
    color: #3088c5;
    font-weight: bold;
    line-height: 30px;
  }
}

// 经销商样式
.dealerInfoList {
  .label {
    margin-bottom: 8px;
    font-size: 14px;
    color: #333;
    line-height: 18px;
  }

  .van-divider {
    margin: 8px 0;
  }
}

.colLabel,
.colValue {
  font-size: 14px;
  color: #333;
  line-height: 30px;
  vertical-align: middle;
}
.useDealerRmark {
  color: #999;
  font-size: 14px;
}
.accordionContent {
  width: 100%;
  :deep(p) {
    word-break: break-all;
  }
}
.loadBox {
  position: fixed;
  left: 0;
  top: 0px;
  width: 100%;
  height: 100%;
  padding-top: 250px;
  background-color: rgba($color: #000000, $alpha: 0.4);
}
.salesAttribute {
  border-bottom: 1px solid #ccc;
  font-style: oblique;
}
.preViewFlag {
  position: absolute;
  right: 10px;
  top: 5px;
  text-align: right;
}
</style>
